import { useState } from "react";
import { Outlet, Navigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import TopBar from "./TopBar";
import EmailVerificationBanner from "./EmailVerificationBanner";
import { useAuthStore } from "../../store/authStore";

export default function DashboardLayout() {
  const { user, organizations } = useAuthStore();
  const [mobileOpen, setMobileOpen] = useState(false);

  // If user is a Relationship Manager / BRM and has no merchant organization memberships, redirect to BRM portal
  if (user?.isBrm && (!organizations || organizations.length === 0)) {
    return <Navigate to="/brm" replace />;
  }

  return (
    <div className="flex h-screen bg-slate-50 overflow-hidden">
      <Sidebar mobileOpen={mobileOpen} setMobileOpen={setMobileOpen} />
      <div className="flex flex-1 flex-col min-w-0 overflow-hidden">
        <TopBar onOpenMobileMenu={() => setMobileOpen(true)} />
        <EmailVerificationBanner />
        <main className="flex-1 overflow-y-auto p-4 sm:p-6 lg:p-8">
          <div className="mx-auto max-w-7xl">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}